import { featureOperations, Features } from '@ardoq/features';
import { getFeatureContext } from 'streams/featureContext$';

export const hasReferenceBubbleChartFeature = (): boolean =>
  featureOperations.hasFeature(
    getFeatureContext(),
    Features.REFERENCE_BUBBLE_CHART_IN_VIEWPOINT_MODE
  );
